import Amount from "@/models/Shared/Amount";

export default class CreateWalletTransferRequest {
    destinationWalletId: string = "";
    amount: Amount = new Amount();
    debitTransactionReference: string = "";
    creditTransactionReference: string = "";
}